export default __webpack_public_path__ + "static/media/inverted-wave.98e87106.svg";